export const VNFILTER_SET_RVC_FILTERS = 'VNFILTER_SET_RVC_FILTERS'
export const VNFILTER_SET_QUERY_PARAM_RVC_FILTERS = 'VNFILTER_SET_QUERY_PARAM_RVC_FILTERS'
